//import { ShapeProfileData } from '@/types/product'

const loadShapeProfile = (data) => ({
  id: data.id || null,
  shape_profile_name: data.name,
  logo_parameters_size_width: data.logo_parameters.size.width,
  logo_parameters_size_height: data.logo_parameters.size.height,
  logo_parameters_offset_y: data.logo_parameters.offset_y,
  logo_parameters_offset_angle: data.logo_parameters.offset_angle,
  logo_parameters_camera_job_id: data.logo_parameters.camera_job_id || data.logo_parameters.camera_job_name_id,
  logo_parameters_led_brightness: data.logo_parameters.led_brightness.white,// === 255 ? 'bright' : 'dark',
  gripper_plane_x: String(data.gripper_plane.position.x),
  gripper_plane_y: String(data.gripper_plane.position.y),
  gripper_plane_z: String(data.gripper_plane.position.z),
  gripper_plane_x_angle: String(data.gripper_plane.angle.x),
  gripper_plane_y_angle: String(data.gripper_plane.angle.y),
  gripper_plane_z_angle: String(data.gripper_plane.angle.z),
  center_of_gravity_x: String(data.center_of_gravity.x) * 1000,
  center_of_gravity_y: String(data.center_of_gravity.y) * 1000,
  center_of_gravity_z: String(data.center_of_gravity.z) * 1000,
  base_point_x: String(data.base_point.x),
  base_point_y: String(data.base_point.y),
  base_point_z: String(data.base_point.z),
  height: String(data.height),
  shape: String(data.shape),
  distance_unit_name: data.distance_unit_name,
  angle_unit_name: data.angle_unit_name,
  mass: String(data.mass),
  mass_unit_name: data.mass_unit_name,
  surface_marking_method: data.surface_marking_method,
  tool_id: data.tool_id,
})

export default loadShapeProfile
